
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    tags: {
      required: true,
      default: () => []
    }
  },
  setup(props, context) {
    const clearTag = tag => {
      context.emit("clearTag", tag);
    };
    return {
      clearTag
    };
  }
});
